var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTerminal = function SvgTerminal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#373737",
    fillRule: "evenodd",
    d: "M3.75 3a1.5 1.5 0 0 0-1.5 1.5v15a1.5 1.5 0 0 0 1.5 1.5h16.5a1.5 1.5 0 0 0 1.5-1.5v-15a1.5 1.5 0 0 0-1.5-1.5zm-3 1.5a3 3 0 0 1 3-3h16.5a3 3 0 0 1 3 3v15a3 3 0 0 1-3 3H3.75a3 3 0 0 1-3-3zm3.164.281a.75.75 0 0 1 1.055-.117l3.75 3a.75.75 0 0 1 0 1.172l-3.75 3a.75.75 0 0 1-.938-1.172L7.05 8.25 4.031 5.836a.75.75 0 0 1-.117-1.055M8.25 11.25A.75.75 0 0 1 9 10.5h3a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1-.75-.75",
    clipRule: "evenodd"
  })));
};
export default SvgTerminal;